module.exports = __webpack_public_path__ + "static/img/labourservices-10.e56917f.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/rescuelist/img/list/labourservices-10.png
// module id = Rp1y
// module chunks = 1